import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  FiFacebook,
  FiTwitter,
  FiLinkedin,
  FiMail,
  FiInstagram
} from "react-icons/fi";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-100 text-gray-700 text-sm border-t">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Branding */}
        <div>
          <img
            src="/assets/images/logo.png"
            alt="TriTech Tunisie Logo"
            className="h-8 mb-4"
          />
          <p className="text-gray-600 text-sm leading-relaxed">
            {t("footer.description")}
          </p>
        </div>

        {/* Services */}
        <div>
          <h4 className="font-semibold mb-3 text-gray-900">{t("footer.services.title")}</h4>
          <ul className="space-y-2">
            <li><Link to="/modules/pool-construction" className="hover:text-primary">{t("footer.services.poolConstruction")}</Link></li>
            <li><Link to="/modules/installation-services" className="hover:text-primary">{t("footer.services.installation")}</Link></li>
            <li><Link to="/modules/equipment-accessories" className="hover:text-primary">{t("footer.services.equipment")}</Link></li>
            <li><Link to="/modules/maintenance-scheduling" className="hover:text-primary">{t("footer.services.maintenance")}</Link></li>
          </ul>
        </div>

        {/* Resources */}
        <div>
          <h4 className="font-semibold mb-3 text-gray-900">{t("footer.resources.title")}</h4>
          <ul className="space-y-2">
            <li><Link to="/use-cases" className="hover:text-primary">{t("footer.resources.projects")}</Link></li>
            <li><Link to="/blog" className="hover:text-primary">{t("footer.resources.blog")}</Link></li>
            <li><Link to="/faq" className="hover:text-primary">{t("footer.resources.faq")}</Link></li>
            <li><Link to="/contact" className="hover:text-primary">{t("footer.resources.support")}</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="font-semibold mb-3 text-gray-900">{t("footer.company.title")}</h4>
          <ul className="space-y-2">
            <li><Link to="/about" className="hover:text-primary">{t("footer.company.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-primary">{t("footer.company.contact")}</Link></li>
            <li><Link to="/quote-request" className="hover:text-primary">{t("footer.company.quote")}</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-primary">{t("footer.company.privacy")}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-200 text-center py-6 px-4 text-xs text-gray-500">
        <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto">
          <p className="mb-3 md:mb-0">&copy; {new Date().getFullYear()} RedERP. {t("footer.rights")} Powered by Red Digital Factory L.L.C Qatar.</p>
          <div className="flex gap-4 text-gray-500">
            <a href="#" className="hover:text-primary"><FiInstagram /></a>
            <a href="#" className="hover:text-primary"><FiTwitter /></a>
            <a href="#" className="hover:text-primary"><FiLinkedin /></a>
            <a href="mailto:info@rederp.pro" className="hover:text-primary"><FiMail /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
